import { NewsletterResponse } from '@/core/domain/newsletter/models/newsletter.model';
import { NewsletterRepository } from '@/core/domain/newsletter/repositories/newsletter.repository';
import { environment } from '@/env/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NewsletterImplRepository extends NewsletterRepository {
    constructor(private readonly http: HttpClient) {
        super();
    }

    override suscribeEmail(email: string): Observable<NewsletterResponse> {
        const params = new HttpParams().set('email', email);
        const url = [
            environment.alamoApi.BASE_HOST,
            environment.alamoApi.ENDPOINTS.subscription,
        ].join('/');

        return this.http.post<NewsletterResponse>(url, null, { params });
    }
}
